import { render } from "../reasons_for_usage/reasons_for_usage.html?vue&type=template&id=0b6bbdfc&external"
import script from "../reasons_for_usage/reasons_for_usage.js?vue&type=script&lang=js&external"
export * from "../reasons_for_usage/reasons_for_usage.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__